import $ from 'jquery';
import Base from '../../../_config/base';

class EmptyColumn extends Base {

  constructor(el) {
    super(el);
    console.log('Empty Column Loaded');

    /*
    let jEl = $(el);

    console.log(el);
    //jEl.find('.title').css('color', 'green');
    */

  }

}

EmptyColumn.className = 'EmptyColumn';
export default EmptyColumn;


// WEBPACK FOOTER //
// ./src/materials/molecules/empty-column/empty-column.js